import { PermissionDomains } from '../../components/v2BaseComponents/Permissions/types';
import { MedicalDataTypes } from '../../primary-record-types';
import { resourceCategoryMessages } from '../../utils/sharedMessages';

export const getCategoryLabel = (category: MedicalDataTypes.PrimaryRecordResourceCategory) => {
    return resourceCategoryMessages(category);
};

export const categoryToDomain = (category: MedicalDataTypes.PrimaryRecordResourceCategory) => {
    const map: Record<MedicalDataTypes.PrimaryRecordResourceCategory, PermissionDomains> = {
        condition: 'conditions',
        medication: 'medications',
        allergy: 'allergies',
        visit: 'visits',
        imaging: 'imaging',
        vaccination: 'vaccinations',
        procedure: 'procedures',
        lab: 'labs',
    };

    return map[category];
};
